import React, { useEffect } from "react";
import { useLoader } from "../context/LoaderContext";
import { useGalleryBannerContext } from "../context/GalleryBannerContext";
import { useGalleryImageContext } from "../context/GalleryImageContext";
import { dynamicFailed } from "../hooks/useToast";
import { fetchGalleryBanner, fetchGalleryData } from "../api/GalleryApi";
import GalleryBanner from "../components/gallery/GalleryBanner";
import Album from "../components/gallery/Album";

const Gallery = () => {
  const { setLoading } = useLoader();
  const { galleryBannerData, setGalleryBannerData } = useGalleryBannerContext();
  const { galleryImageData, setGalleryImageData } = useGalleryImageContext();

  useEffect(() => {
    setLoading(true);
    if (galleryBannerData.length === 0 || galleryImageData.length === 0) {
      Promise.all([fetchGalleryData(), fetchGalleryBanner()])
        .then(([galleryData, galleryBannerData]) => {
          setGalleryImageData(galleryData);
          setGalleryBannerData(galleryBannerData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          dynamicFailed("Server Error");
        });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [
    galleryBannerData.length,
    galleryImageData.length,
    setGalleryBannerData,
    setGalleryImageData,
    setLoading,
  ]);
  return (
    <>
      <GalleryBanner galleryBannerData={galleryBannerData} />
      <Album galleryImageData={galleryImageData}/>
    </>
  );
};

export default Gallery;
